// extracted by mini-css-extract-plugin
export default {"appPageWrapper":"App_appPageWrapper__g9TWb","appPageWrapperNoTopInset":"App_appPageWrapperNoTopInset__x-evv"};